import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Section from '@atoms/Section/Section';
import Text from '@atoms/Text/Text';
import Title from '@atoms/Title/Title';
import Link from '@components/Link';

type ListData = {
    title: string;
    list: Array<{ title?: string; url?: string; isLink?: boolean }>;
};

interface Props {
    data: ListData;
}

const HeaderNavSubMenuList: React.FC<Props> = ({ data }) => {
    const { t } = useTranslation();

    return (
        <Section spacingBottom="s">
            <Text
                size="m"
                theme="white"
                className="HeaderNavSubMenuList--header"
            >
                {t(data.title)}
            </Text>

            {data.list.map((i) =>
                i.customLink ? (
                    i.customLink
                ) : i.title ? (
                    <Title size="m" theme="white">
                        <Link to={i.url} className={i.isLink ? 'is-link' : ''}>
                            {t(i.title)}
                        </Link>
                    </Title>
                ) : null
            )}
        </Section>
    );
};

export default HeaderNavSubMenuList;
